<template>
  <v-chip :color="getContractStatusColor(status)" variant="tonal" density="compact" label :prepend-icon="getContractStatusIcon(status)">
    <span class="text-high-emphasis">{{ $t(`contracts.status.${status}`) }}</span>
  </v-chip>
</template>

<script setup lang="ts">
defineProps<{ status: ContractStatus }>()
</script>
